import React, { Fragment, useState } from 'react';
import { object, string, bool, func } from 'prop-types';

import WeddingImg from '@assets/images/wedding-logo.png';
import CountContainer from './CountContainer';
import ScrollToDown from './ScrollToDown';
import { styWrapper, styHero, styBackground } from './styles';

const DELAY_TIME = 1500;

function WelcomeSection({ location, guestName, type, isAnonymGuest, codeLink, onClickDetail }) {
  const [loading, setLoading] = useState(false);
  const [alreadyDownloadData, setAlreadyDownloadData] = useState(false);

  const handleScrollTo = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    /** scroll into detail view */
    const element = document.getElementById('fh5co-couple');
    if (element) {
      // Sử dụng requestAnimationFrame để tối ưu scroll performance
      requestAnimationFrame(() => {
        // Trên mobile, dùng 'auto' thay vì 'smooth' để tránh lag
        const isMobile = window.innerWidth <= 768;
        element.scrollIntoView({
          behavior: isMobile ? 'auto' : 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      });
    }
  };

  const handleShowDetail = () => {
    if (loading) return undefined;

    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      try {
        const myAudio = document.getElementById('myAudio');
        if (myAudio) {
          myAudio.play();
        }
      } catch {
        console.error('FAILED_TO_PLAY_MUSIC');
      }
    }

    onClickDetail();

    if (!alreadyDownloadData) {
      setLoading(true);

      setTimeout(() => {
        setLoading(false);
        setAlreadyDownloadData(true);
        handleScrollTo();
      }, DELAY_TIME);
    } else {
      handleScrollTo();
    }
  };

  const renderGuestSection = () => {
    if (isAnonymGuest) return <h2 className="to-dearest-name">Trân trọng kính mời</h2>;

    return (
      <Fragment>
        <h3 className="to-dearest">Trân trọng kính mời {type}</h3>
        <h2 className="to-dearest-name">{guestName}</h2>
      </Fragment>
    );
  };

  return (
    <div css={styHero}>
      <header
        id="fh5co-header"
        role="banner"
        className="fh5co-cover"
        css={styBackground}
        data-stellar-background-ratio="0.5"
      >
        <div className="overlay"></div>
        <div className="container">
          <div className="row" css={styWrapper}>
            <div className="col-md-8 col-md-offset-2 text-center">
              <img src={WeddingImg} alt="wedding-dinda-indra" loading="lazy" />
              <h4 className="sub-title">The Wedding of</h4>
              <h1 className="title main-font">Trần Dũng &amp; Khánh Ly</h1>
              <div className={isAnonymGuest ? 'margin__bottom' : ''}>
                <CountContainer />
              </div>
              {renderGuestSection()}
            </div>
          </div>
          <div className="row">
            <ScrollToDown loading={loading} onClick={handleShowDetail} />
          </div>
        </div>
      </header>
    </div>
  );
}

WelcomeSection.propTypes = {
  guestName: string.isRequired,
  isInvitation: bool.isRequired,
  isAnonymGuest: bool.isRequired,
  location: object.isRequired,
  codeLink: string,
  onClickDetail: func.isRequired,
};

WelcomeSection.defaultProps = {
  codeLink: '',
};

export default React.memo(WelcomeSection);
